import { isTrashedListing } from '../components/MyListingsSection/MyListingsSection.helpers';
import { isCampaignInboxListing } from './practitionerCampaign';
import {
  DIGITAL_PRODUCT_LISTING_TYPES,
  GROUP_SESSION_LISTING_TYPES,
  INDIVIDUAL_SESSION_LISTING_TYPES,
  isDigitalProductListingType,
  isGroupSession,
  isIndividualSession,
} from './soulwise-marketplace/listingType';

export const LISTING_TYPE_TAB = {
  ALL: 'all',
  GROUP: 'group',
  INDIVIDUAL: 'individual',
  CONTENT: 'content',
};

export const LISTING_TYPE_TAB_OPTIONS = [
  {
    id: LISTING_TYPE_TAB.ALL,
    messageId: 'ListingTypeTabs.all',
    countMessageId: 'ListingTypeTabs.all.withCount',
  },
  {
    id: LISTING_TYPE_TAB.GROUP,
    messageId: 'ListingTypeTabs.groupEvents',
    countMessageId: 'ListingTypeTabs.groupEvents.withCount',
  },
  {
    id: LISTING_TYPE_TAB.INDIVIDUAL,
    messageId: 'ListingTypeTabs.individualSessions',
    countMessageId: 'ListingTypeTabs.individualSessions.withCount',
  },
  {
    id: LISTING_TYPE_TAB.CONTENT,
    messageId: 'ListingTypeTabs.content',
    countMessageId: 'ListingTypeTabs.content.withCount',
  },
];

export const emptyListingTypeTabCounts = () => ({
  [LISTING_TYPE_TAB.ALL]: 0,
  [LISTING_TYPE_TAB.GROUP]: 0,
  [LISTING_TYPE_TAB.INDIVIDUAL]: 0,
  [LISTING_TYPE_TAB.CONTENT]: 0,
});

/**
 * Own listings that type-filter counts include: every Sharetribe state the
 * Manage Listings page lists (draft, published, closed, pendingApproval),
 * excluding trash and campaign-inbox rows.
 */
export const isCountableManageListing = listing =>
  !!listing && !isCampaignInboxListing(listing) && !isTrashedListing(listing);

const getListingType = listing => listing?.attributes?.publicData?.listingType;

export const getListingTypeTabForListing = listing => {
  const listingType = getListingType(listing);
  if (isDigitalProductListingType(listingType)) {
    return LISTING_TYPE_TAB.CONTENT;
  }
  if (isIndividualSession(listingType)) {
    return LISTING_TYPE_TAB.INDIVIDUAL;
  }
  if (isGroupSession(listingType)) {
    return LISTING_TYPE_TAB.GROUP;
  }
  return LISTING_TYPE_TAB.ALL;
};

export const filterListingsByTypeTab = (listings, tab) => {
  if (!tab || tab === LISTING_TYPE_TAB.ALL) {
    return listings || [];
  }
  return (listings || []).filter(listing => getListingTypeTabForListing(listing) === tab);
};

export const getPresentListingTypeTabs = listings => {
  const present = new Set((listings || []).map(getListingTypeTabForListing));
  const tabs = LISTING_TYPE_TAB_OPTIONS.filter(option => {
    if (option.id === LISTING_TYPE_TAB.ALL) {
      return false;
    }
    return present.has(option.id);
  }).map(option => option.id);

  if (tabs.length <= 1) {
    return [];
  }

  return [LISTING_TYPE_TAB.ALL, ...tabs];
};

export const countListingsByTypeTab = listings => {
  const counts = emptyListingTypeTabCounts();
  (listings || []).forEach(listing => {
    if (!isCountableManageListing(listing)) {
      return;
    }
    counts[LISTING_TYPE_TAB.ALL] += 1;
    const tab = getListingTypeTabForListing(listing);
    if (tab && tab !== LISTING_TYPE_TAB.ALL && counts[tab] != null) {
      counts[tab] += 1;
    }
  });
  return counts;
};

export const getPresentListingTypeTabsFromCounts = counts => {
  const safe = counts || emptyListingTypeTabCounts();
  const tabs = LISTING_TYPE_TAB_OPTIONS.filter(
    option => option.id !== LISTING_TYPE_TAB.ALL && safe[option.id] > 0
  ).map(option => option.id);

  if (tabs.length <= 1) {
    return [];
  }

  return [LISTING_TYPE_TAB.ALL, ...tabs];
};

export const listingTypeTabSearchValues = {
  [LISTING_TYPE_TAB.GROUP]: GROUP_SESSION_LISTING_TYPES,
  [LISTING_TYPE_TAB.INDIVIDUAL]: INDIVIDUAL_SESSION_LISTING_TYPES,
  [LISTING_TYPE_TAB.CONTENT]: DIGITAL_PRODUCT_LISTING_TYPES,
};
